module.exports = __webpack_public_path__ + "media/widgets/join-fastweb-match-instantly_1300x1300__2x-44e76419.png";